import React, { Suspense, startTransition, useEffect, useState } from "react";
import Header from "../components/Header/Header";
import AppNavMenu from "../components/AppNav/AppNavMenu";

const About = React.lazy(() => import("../components/About/About"));
const Services = React.lazy(() => import("../components/Services/Services"));
const Experinces = React.lazy(() => import("../components/Experinces"));
const Contact = React.lazy(() => import("../components/Contact/Contact"));
const Footer = React.lazy(() => import("../components/Footer/Footer"));
const ProjectsPages = React.lazy(() =>
  import("../components/Projects/ProjectsPages")
);
const BeyondCode = React.lazy(() =>
  import("../components/BeyondCode/BeyondCode")
);

export default function Home() {
  const [languageState, setLanguageState] = useState(1);
  const [showRest, setShowRest] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("language");
    if (stored !== null && stored !== "1") {
      setLanguageState(stored);
    }
  }, []);

  useEffect(() => {
    const reveal = () => startTransition(() => setShowRest(true));
    if (window.requestIdleCallback) {
      const id = window.requestIdleCallback(reveal, { timeout: 1 });
      return () => window.cancelIdleCallback(id);
    }
    const id = window.setTimeout(reveal, 1);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <div>
      <AppNavMenu
        languageState={languageState}
        setLanguageState={setLanguageState}
      />
      <Header languageState={languageState} />
      <main>
        {showRest && (
          <Suspense fallback={null}>
            <About languageState={languageState} />
            <Services languageState={languageState} />
            <ProjectsPages languageState={languageState} />
            <Experinces languageState={languageState} />
            <BeyondCode languageState={languageState} />
            <Contact languageState={languageState} />
            <Footer languageState={languageState} />
          </Suspense>
        )}
      </main>
    </div>
  );
}
